<template>
  <div class="arrow background" :class="{ left: left, right: right, background: background, disabled: disabled }">
    <span class="af background" :class="{ 'af-chevron-left': left, 'af-chevron-right': right }"></span>
  </div>
</template>

<script>
export default {
  name: 'ImageGalleryArrow',
  props: {
    left: Boolean,
    right: Boolean,
    color: {
      type: String,
      default: 'white',
    },
    background: Boolean,
    disabled: Boolean,
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.arrow {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  width: 32px;
  height: 32px;
  padding: 8px;
  text-align: center;
  top: calc(50% - 24px);
  transition: visibility 0s linear 100ms, opacity 100ms ease-in;
  user-select: none;

  &,
  * {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  span {
    color: var(--link-color);
    font-size: 1em;
  }

  &.right {
    right: var(--space-12);
  }

  &.left {
    left: var(--space-12);
  }

  @media (min-width: $desktop-breakpoint) {
    &.right {
      right: var(--space-16);
    }

    &.left {
      left: var(--space-16);
    }
  }

  &.background {
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
    transition: background 100ms ease-in;

    /* purgecss ignore */
    &:hover {
      background: rgba(255, 255, 255, 1);
    }
  }
  &.disabled {
    opacity: 50%;
  }
}
</style>
